import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPerson } from "@fortawesome/free-solid-svg-icons";
import "./OccupancyInput.css";

export default function OccupancyInput({ nextStep, updateFormData }) {
  const [numPeople, setNumPeople] = useState(2);
  const [occupancy, setOccupancy] = useState("");
  const [error, setError] = useState("");

  const occupancyOptions = [
    { label: "🕐 Someone is home all day", value: "someone home all day" },
    { label: "⏱️ Someone is home for half of the day", value: "home half the day" },
    { label: "🕘 Nobody is home during the day", value: "nobody home during the day" },
  ];

  const handleContinue = () => {
    if (numPeople < 1) {
      setError("Please select at least one person.");
      return;
    }
    if (occupancy === "") {
      alert("Please select an occupancy option.");
      return;
    }
    setError(""); // Clear any previous error

    // Determine occupancy factor based on schedule
    let scheduleFactor = 0.60; // default to home half the day
    if (occupancy === "someone home all day") {
      scheduleFactor = 0.7;
    } else if (occupancy === "nobody home during the day") {
      scheduleFactor = 0.5;
    }

    updateFormData({
      numPeople: numPeople,
      occupancyFactor: scheduleFactor,
      occupancySchedule: occupancy,
    });
    nextStep();
  };

  return (
    <div className="occupancy-container">
      <h2>Occupancy and electricity usage</h2>
      <p className="intro-para">
        Please tell us how many people live at the address and how often you're there.{" "}
        <em>This helps us to estimate system size, usage and savings more accurately.</em>
      </p>

      <label htmlFor="numPeople" className="slider-label">How many people live here?</label>
      <input
        id="numPeople"
        type="range"
        min="0"
        max="6"
        value={numPeople}
        onChange={(e) => setNumPeople(parseInt(e.target.value))}
      />
      <div className="people-icons">
        {[...Array(numPeople)].map((_, i) => (
          <FontAwesomeIcon key={i} icon={faPerson} size="3x" />
        ))}
      </div>
      <p className="people-count">{numPeople} {numPeople === 1 ? "person" : "people"}</p>

      <h3>When are people typically home?</h3>
      <div className="occupancy-options">
        {occupancyOptions.map(({ label, value }) => (
          <button
            key={value}
            type="button"
            className={occupancy === value ? "occupancy-btn selected" : "occupancy-btn"}
            onClick={() => setOccupancy(value)}
          >
            {label}
          </button>
        ))}
      </div>

      {error && <p className="error-message">{error}</p>}

      <button className="continue-button" onClick={handleContinue}>
        Continue
      </button>
    </div>
  );
}
